import { CardGroupCard, Color, ContentFilter, ContentFilterType, ContentTableItem, IconName } from '@elearning-platform/ui';

import { LessonStatus } from '../../enums';

import { CategoryFilter, FilterName } from './knowledgeBaseV2.enums';
import { FilterableAttribute } from './knowledgeBaseV2.types';

export const skeletonCardItem: CardGroupCard = {
  image: '',
  title: '',
  tags: ['', ''],
  category: '',
};

export const skeletonTableItem: ContentTableItem = {
  type: 'lessonItem',
  data: [
    { value: '', type: 'image', name: 'image' },
    { value: '', type: 'title', name: 'title', contentType: '' },
    {
      type: 'label',
      value: {
        list: ['-', '-'],
        colorsData: {
          textColor: Color.Gray600,
          backgroundColor: Color.White,
          borderColor: Color.Gray300,
        },
      },
      name: 'labels',
    },
    {
      icons: [
        { name: IconName.Award, color: Color.Silver },
        { name: IconName.CheckmarkCircle, color: Color.Green300 },
      ],
      type: 'icons',
      name: 'status',
    },
    {
      type: 'action',
      name: 'actions',
      value: [{ actionType: 'download' }],
    },
  ],
};

export const filterableAttributes: FilterableAttribute[] = [
  {
    value: 'required',
    label: 'competence.app.knowledgeBaseV2.filters.required',
  },
  {
    value: 'cyclical',
    label: 'competence.app.knowledgeBaseV2.filters.cyclical',
  },
];

export const filters: ContentFilter[] = [
  {
    name: FilterName.Status,
    label: 'competence.app.knowledgeBaseV2.filters.status',
    type: ContentFilterType.Multiselect,
    options: [
      { value: LessonStatus.NotStarted, label: 'competence.app.knowledgeBaseV2.filters.notStarted' },
      { value: LessonStatus.InProgress, label: 'competence.app.knowledgeBaseV2.filters.inProgress' },
      { value: LessonStatus.Finished, label: 'competence.app.knowledgeBaseV2.filters.finished' },
      { value: LessonStatus.Failed, label: 'competence.app.knowledgeBaseV2.filters.failed' },
    ],
  },
  {
    name: FilterName.Attributes,
    label: 'competence.app.knowledgeBaseV2.filters.attributes',
    type: ContentFilterType.Multiselect,
    options: filterableAttributes,
  },
  {
    name: FilterName.Type,
    label: 'competence.app.knowledgeBaseV2.filters.type',
    type: ContentFilterType.Multiselect,
    options: [
      { value: CategoryFilter.ELearning, label: 'competence.app.knowledgeBaseV2.filters.eLearning' },
      { value: CategoryFilter.Video, label: 'competence.app.knowledgeBaseV2.filters.video' },
      { value: CategoryFilter.Files, label: 'competence.app.knowledgeBaseV2.filters.documents' },
      { value: 'favorite', label: 'competence.app.knowledgeBaseV2.filters.favorite' },
    ],
  },
];
